import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectPlacementTypeFilter } from 'shared/selectors/advancedFilters';
import { EPlacementType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const PlacementTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectPlacementTypeFilter);

  const onChange = useFilterChangeCallback();

  const handlePlacementTypeChange = useCallback(
    (newValue: NonEmptyArray<EPlacementType> | null) => {
      onChange({ action: 'setPlacementType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handlePlacementTypeChange} />
    </AdvancedFilterRow>
  );
};
